import { ChangePasswordComponent } from './change-password/change-password.component';
import { AdminStateComponent } from './admin-state/state.component';
import { PartialReportComponent } from './partial-report/partial-report.component'
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RoleGuardService as RoleGuard } from './auth/role-guard.service';

import { SigninComponent } from './auth/signin/signin.component';
import { AppComponent } from './app.component';
import { AuthGuard } from './auth/auth-guard.service';
import { LayoutsComponent } from './layouts/layouts.component';
import { TerminalActionsSsbtReportComponent } from './terminal-actions-ssbt-report/terminal-actions-ssbt-report.component';
import { TerminalConnectivityStatusReportComponent } from './terminal-connectivity-status-report/terminal-connectivity-status-report.component';
import { AverageTrafficComponent } from './average-traffic/average-traffic.component';
import { TerminalOverviewReportComponent } from './terminal-overview-report/terminal-overview-report.component';
import { UnpaidComponent } from './unpaid/unpaid.component';

export const appRoutes: Routes = [
  {
    path: '', component: LayoutsComponent, canActivate: [AuthGuard],
    children: [
      {
        path: 'state', component: AdminStateComponent, canActivate: [AuthGuard, RoleGuard],
        data: {
         expectedRole: [],
         forbiddenRole: []
        },
      },
      {
        path: 'terminalreport', component: PartialReportComponent, canActivate: [AuthGuard, RoleGuard],
        data: {
         expectedRole: [],
         forbiddenRole: []
        },
      },
      {
        path: 'changepassword', component: ChangePasswordComponent, canActivate: [AuthGuard, RoleGuard],
        data: {
          expectedRole: [],
          forbiddenRole: []
         },
      },
      {
        path: 'terminalActionsSsbtReport', component: TerminalActionsSsbtReportComponent, canActivate: [AuthGuard, RoleGuard],
        data: {
          expectedRole: [],
          forbiddenRole: []
         },
      },
      {
        path: 'terminalConnectivityStatusReport', component: TerminalConnectivityStatusReportComponent, canActivate: [AuthGuard, RoleGuard],
        data: {
          expectedRole: [],
          forbiddenRole: []
         },
      },
      {
        path: 'averageTrafficReport', component: AverageTrafficComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: {
         expectedRole: ['ADMIN', 'REGIONAL_MANAGER', 'REGIONAL_MANAGER_BETSHOP', 'REGIONAL_MANAGER_TERMINAL'],
         forbiddenRole: []
        },
      },
      {
        path: 'terminalOverviewReport', component: TerminalOverviewReportComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: {
         expectedRole: ['ADMIN', 'REGIONAL_MANAGER', 'REGIONAL_MANAGER_BETSHOP', 'REGIONAL_MANAGER_TERMINAL'],
         forbiddenRole: []
        },
      },
      {
        path: 'unpaid', component: UnpaidComponent, canActivate: [AuthGuard, RoleGuard],
        data: {
         expectedRole: [],
         forbiddenRole: []
        },
      },
    ]
  },
  { path: 'signin', component: SigninComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/app.routing.ts